export const report = (error: Error) => {
  console.log(error)
}
